import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactDatePicker from "../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "./redux/sagas/monthSwitcher/monthSwitcher";

export class MonthSwitcherModule extends React.Component {
  componentDidMount() {
    this.props.updateDate(this.props.params.calendarEndDate);
  }

  updateDates = (startDate, endDate) => {
    this.props.updateDate(endDate);
  };

  render() {
    return (
      <div>
        <div className="select-wrapper">
          <p>Month to Date:</p>
          <ReactDatePicker startDate={this.props.date} calendarEndDate={this.props.params.calendarEndDate} updateDates={this.updateDates} />
        </div>
      </div>
    );
  }
}

MonthSwitcherModule.propTypes = {
  params: PropTypes.object.isRequired,
  updateDate: PropTypes.func.isRequired,
  date: PropTypes.string
};

export default connect(
  state => ({
    date: state.monthSwitcher.date
  }),
  {
    updateDate: actionCreators.updateDate
  }
)(MonthSwitcherModule);
